export const PERMISSION_RESOURCE_CODES = {
  home: 'home',
  comments: 'comments',
  commentReports: 'comment-reports',
  commentSensitiveWords: 'comment-sensitive-words',
  settings: 'settings',
} as const;

export const PERMISSION_ACTION_CODES = {
  home: {},
  comments: {
    delete: 'delete',
  },
  commentReports: {
    manage: 'manage',
    delete: 'delete',
  },
  commentSensitiveWords: {
    create: 'create',
    edit: 'edit',
    enable: 'enable',
    disable: 'disable',
    delete: 'delete',
  },
  settings: {},
};
